var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkills(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.947 31.38L48.199 6.391 36.457 18.326l25.748 24.986L73.948 31.38zM59.54 77.471L33.793 52.485 22.052 64.418 47.8 89.405 59.54 77.472zm30.252-29.375l-25.16 25.57-12.015-11.66 25.16-25.57 12.015 11.66zM18.221 59.36l25.16-25.57L31.366 22.13 6.206 47.7 18.22 59.362z",
    fill: "currentColor"
  })));
}
export default SvgSkills;